const themes = {
  numbers: {
    first: '0',
    second: '1',
  },
  symbols: {
    first: '-',
    second: '+',
  },
  currencies: {
    first: '$',
    second: '€',
  },
}

export { themes };